var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "scale-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [_vm._v("Масштаб")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: {
            src: _vm.urlForStatic(
              "/img/projectPreviewsDemo/perspective_tip_1.svg"
            )
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "Установите масштаб проекта. Поставьте две точки в рабочей области таким образом, чтобы "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("длина")]),
      _vm._v(" получившегося отрезка "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("на реальном объекте")
      ]),
      _vm._v(" была вам "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("точно известна")
      ]),
      _vm._v(
        ". Примерами такого отрезка могут быть длина стены или высота двери."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Старайтесь выбирать объекты, которые находятся как можно "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("ближе")]),
      _vm._v(" к наблюдателю и находятся под близким к "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("прямому углу")
      ]),
      _vm._v(" к точке обзора. Это увеличит точность визуализации и расчетов")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }